/* BlackBork Bundle Protection - No longer needed, discount handles pricing */

/* BlackBork Meta fbp/fbc bridge v2026-05-31.
   Runs from an existing cached asset so Shopify page_cache cannot block the fix. */
(function(){
  try {
    if (window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.marketingAllowed === 'function' &&
        !window.Shopify.customerPrivacy.marketingAllowed()) return;
    function getCookie(n){
      var m = document.cookie.split('; ').find(function(c){return c.indexOf(n+'=')===0;});
      return m ? decodeURIComponent(m.split('=').slice(1).join('=')) : null;
    }
    function validFbc(v){ return /^fb\.\d+\.\d+\.[A-Za-z0-9_-]+$/.test(String(v || '')); }
    var fbp = getCookie('_fbp');
    var fbc = getCookie('_fbc');
    var fbclid = new URLSearchParams(location.search).get('fbclid');
    var capturedAt = null;

    if (fbc && (!validFbc(fbc) || (fbclid && fbc.split('.').slice(3).join('.') !== fbclid))) {
      capturedAt = Date.now();
      fbc = 'fb.1.' + capturedAt + '.' + (fbclid || fbc.split('.').slice(3).join('.'));
      document.cookie = '_fbc=' + fbc + '; path=/; max-age=7776000; SameSite=Lax; Secure';
    }
    if (!fbc && fbclid) {
      capturedAt = Date.now();
      fbc = 'fb.1.' + capturedAt + '.' + fbclid;
      document.cookie = '_fbc=' + fbc + '; path=/; max-age=7776000; SameSite=Lax; Secure';
    }

    try {
      if (fbp) {
        localStorage.setItem('bb_fbp', fbp);
        localStorage.setItem('_fbp', fbp);
      }
      if (fbc && validFbc(fbc)) {
        localStorage.setItem('bb_fbc', fbc);
        localStorage.setItem('_fbc', fbc);
        localStorage.setItem('_fbc_captured', JSON.stringify({fbc: fbc, capturedAt: capturedAt || Date.now(), fbclid: fbclid || fbc.split('.').slice(3).join('.')}));
      }
    } catch(e) {}

    var attrs = {};
    if (fbp && sessionStorage.getItem('bb_fbp_synced_value') !== fbp) attrs._fbp = fbp;
    if (fbc && validFbc(fbc) && sessionStorage.getItem('bb_fbc_synced_value') !== fbc) {
      attrs._fbc = fbc;
      if (capturedAt) attrs._fbc_captured_at = String(capturedAt);
      if (fbclid) attrs._fbclid = fbclid;
    }
    if (!Object.keys(attrs).length) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({attributes: attrs})
    }).then(function(){
      try {
        if (attrs._fbp) {
          sessionStorage.setItem('bb_fbp_synced', '1');
          sessionStorage.setItem('bb_fbp_synced_value', attrs._fbp);
        }
        if (attrs._fbc) {
          sessionStorage.setItem('bb_fbc_synced', '1');
          sessionStorage.setItem('bb_fbc_synced_value', attrs._fbc);
        }
      } catch(e) {}
    }).catch(function(){});
  } catch(e) {}
})();
